import { createApp } from 'vue'
import App from './App.vue'

import './assets/main.css';
import './assets/share-overrides.css';


createApp(App).mount('#app')
